import {
  CORE_LOAD_ALL_PROFILE_REQUEST,
  CORE_LOAD_ALL_PROFILE_SUCCESS,
  CORE_LOAD_ALL_PROFILE_FAILURE,

  CORE_LOAD_PROFILE_REQUEST,
  CORE_LOAD_PROFILE_SUCCESS,
  CORE_LOAD_PROFILE_FAILURE,

  REQUEST_STATE
} from '../types'

const initialState = []
  , initialStateObj = {}
  , requestState = REQUEST_STATE
export default {
  allProfile: (state = requestState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALL_PROFILE_REQUEST:
        return requestState
      case CORE_LOAD_ALL_PROFILE_SUCCESS:
        if (action.payload && Array.isArray(action.payload)) {
          return action.payload
        } else return []
      case CORE_LOAD_ALL_PROFILE_FAILURE:
        return initialState
      default:
        return state
    }
  },
  profileInfo: (state = requestState, action) => {
    switch (action.type) {
      case CORE_LOAD_PROFILE_REQUEST:
        return requestState
      case CORE_LOAD_PROFILE_SUCCESS:
        if (action.payload && typeof action.payload === 'object' && !Array.isArray(action.payload)) {
          return action.payload
        } else return {}
      case CORE_LOAD_PROFILE_FAILURE:
        return initialStateObj
      default:
        return state
    }
  },
}



// WEBPACK FOOTER //
// ./src/reducers/reducerProfile.js